module.exports = __webpack_public_path__ + "static/media/brand_elo.17f4fd90.svg";